import PropTypes from 'prop-types';

export const stepPropTypes = {
  answers: PropTypes.object.isRequired,
  setAnswers: PropTypes.func.isRequired,
  jobAdParams: PropTypes.object.isRequired,
  requiredRefs: PropTypes.object.isRequired,
  activeError: PropTypes.object
};
